export const getCommentsToastScope = (positionGuid: string) => `comments-${positionGuid}`;
